import React from 'react'
import MainUserStoryFormInput from '../../input-components/user-story/MainUserStoryFormInput'
import { Box, Typography } from '@mui/material'
const UserStoryInputPage = () => {
   return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        bgcolor: "#f6f3f2",
        minHeight: "100vh",
        width: "100%",
        overflowY: "auto",
        position: "relative",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
          minHeight: "20px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      {/* Responsive Content Container */}
      <Box
        sx={{
          width: "100%",
          mx: "auto", // center horizontally
          maxWidth: {
            xs: "100%",   // mobile
            sm: "100%",   // tablet
            md: "95%",    // small laptop
            lg: "90%",    // desktop
            xl: "1266px", // large desktop
          },
          px: { xs: 2, sm: 3, md: 4, lg: 5 }, // responsive padding
          py: 2,
          mb: 10, // extra bottom space for footer
        }}
      >
        <MainUserStoryFormInput />
      </Box>

      {/* Sticky Footer */}
      <Box
        component="footer"
        sx={{
          width: "100%",
          // maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
    </Box>
  )
}

export default UserStoryInputPage;